import { render } from "./EditPointVente.vue?vue&type=template&id=4358f628&ts=true"
import script from "./EditPointVente.vue?vue&type=script&lang=ts"
export * from "./EditPointVente.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__